import { AxiosResponse } from 'axios';
import { SET_MINYAN_ROLLS_N, SET_MINYAN_ROLL_N, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_MINYAN_ROLL_N_ISLOADING,
  DELETE_MINYAN_ROLL_N,
  EDIT_MINYAN_ROLL_N,
  GET_MINYAN_ROLL_N,
  GET_MINYAN_ROLLS_N,
  MOVE_MINYAN_ROLL_N_TO_FOLDER,
  REGISTER_MINYAN_ROLL_N,
  TOGGLE_MINYAN_ROLL_N_IS_ACTIVE,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import MinyanRoll_N from '@/services/minyan_roll_N';
import { Module } from 'vuex';
import { EditMinyanRoll_N, RegisterMinyanRoll_N, GetMinyanRoll_N, MoveMinyanRoll_NToFolder } from '@/dtos/minyan_roll_N.dto';

const minyanRoll_N: Module<any, {}> = {
  state: {
    minyanRoll_N: {
      data: null,
      isLoading: false,
    },
    minyanRolls_N: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    minyanRoll_N: (state: { minyanRoll_N: any }) => state.minyanRoll_N,
    minyanRolls_N: (state: { minyanRolls_N: any }) => state.minyanRolls_N,
  },
  mutations: {
    [SET_MINYAN_ROLL_N]: (
      state: { minyanRoll_N: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.minyanRoll_N.data = payload.data) : null,
        (state.minyanRoll_N.isLoading = payload.isLoading);
    },
    [SET_MINYAN_ROLLS_N]: (
      state: { minyanRolls_N: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.minyanRolls_N.data = payload.data) : null,
        (state.minyanRolls_N.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_MINYAN_ROLL_N]: async ({ commit }: any, payload: RegisterMinyanRoll_N) => {
      commit(SET_MINYAN_ROLL_N, { data: null, isLoading: true });

      const result: AxiosResponse = await MinyanRoll_N.registerMinyanRoll_N(
        payload
      );

      if (result) {
        if (result.data.status) {
          commit(SET_MINYAN_ROLL_N, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_MINYAN_ROLL_N, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_MINYAN_ROLL_N, { isLoading: false });
        return false;
      }
    },
    [GET_MINYAN_ROLLS_N]: async ({ commit }: any, payload: any) => {
      commit(SET_MINYAN_ROLLS_N, { data: null, isLoading: true });

      const result: AxiosResponse = await MinyanRoll_N.getMinyanRolls_N(
        payload as GetMinyanRoll_N
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_MINYAN_ROLLS_N, { data: result.data.data, isLoading: false });
          return result.data.data;
        }
        commit(SET_MINYAN_ROLLS_N, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_MINYAN_ROLLS_N, { isLoading: false });
        return false;
      }
    },
    [GET_MINYAN_ROLL_N]: async ({ commit }: any, payload: any) => {
      commit(SET_MINYAN_ROLL_N, { data: null, isLoading: true });

      const result: AxiosResponse = await MinyanRoll_N.getMinyanRolls_N(
        payload as GetMinyanRoll_N
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_MINYAN_ROLL_N, { data: result.data.data[0], isLoading: false });
          return true;
        }
        commit(SET_MINYAN_ROLL_N, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_MINYAN_ROLL_N, { isLoading: false });
        return false;
      }
    },
    [EDIT_MINYAN_ROLL_N]: async ({ commit }: any, payload: EditMinyanRoll_N) => {
      commit(SET_MINYAN_ROLL_N, { data: null, isLoading: true });

      const result: AxiosResponse = await MinyanRoll_N.editMinyanRoll_N(
        payload
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_MINYAN_ROLL_N, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_MINYAN_ROLL_N, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_MINYAN_ROLL_N, { isLoading: false });
        return false;
      }
    },
    [DELETE_MINYAN_ROLL_N]: async ({ commit }: any, payload: string) => {
      commit(SET_MINYAN_ROLL_N, { data: null, isLoading: true });

      const result: AxiosResponse = await MinyanRoll_N.deleteMinyanRoll_N(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_MINYAN_ROLL_N, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_MINYAN_ROLL_N, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_MINYAN_ROLL_N, { isLoading: false });
        return false;
      }
    },
    [MOVE_MINYAN_ROLL_N_TO_FOLDER]: async ({ commit }: any, payload: any) => {
      commit(SET_MINYAN_ROLL_N, { data: { id: payload.id }, isLoading: true });

      const result: AxiosResponse = await MinyanRoll_N.moveMinyanRoll_NToFolder(
        payload as MoveMinyanRoll_NToFolder
      );

      if (result) {
        if (result.data.status) {
          commit(SET_MINYAN_ROLL_N, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_MINYAN_ROLL_N, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_MINYAN_ROLL_N, { isLoading: false });
        return false;
      }
    },
    [TOGGLE_MINYAN_ROLL_N_IS_ACTIVE]: async ({ commit, state }: any, payload: { id: string }) => {
      commit(SET_MINYAN_ROLL_N, { data: { id: payload.id }, isLoading: true });

      const result: AxiosResponse = await MinyanRoll_N.toggleMinyanRoll_NIsActive(payload);

      if (result) {
        if (result.data.status) {
          let index: number | null = null;
          if (state.minyanRolls_N?.data && Array.isArray(state.minyanRolls_N.data)) {
            state.minyanRolls_N.data.forEach((e: any, i: number) => {
              if (e.id == result.data.data.id) {
                index = i;
              }
            });
            if (index != null) {
              state.minyanRolls_N.data[index].isActive = result.data.data.isActive;
            }
          }
          commit(SET_MINYAN_ROLL_N, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_MINYAN_ROLL_N, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_MINYAN_ROLL_N, { isLoading: false });
        return false;
      }
    },
    [CLEAR_MINYAN_ROLL_N_ISLOADING]: ({ commit }) => {
      commit(SET_MINYAN_ROLL_N, { isLoading: false });
      commit(SET_MINYAN_ROLLS_N, { isLoading: false });
    },
  },
};

export default minyanRoll_N;

